
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/[username]",
      function () {
        return require("private-next-pages/guide/[username].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/[username]"])
      });
    }
  